import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-2 border-h-primary-200 p-4 py-4 rounded-md bg-neutral-50 flex justify-between" }
const _hoisted_2 = { class: "text-neutral-800 capitalize" }
const _hoisted_3 = { class: "text-neutral-800 mt-1 text-[12px]" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "hidden sm:block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaterialModal = _resolveComponent("MaterialModal")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.configModal.showMaterials)
      ? (_openBlock(), _createBlock(_component_MaterialModal, {
          key: 0,
          materials: _ctx.currentMaterials,
          learningObjective: _ctx.currentObjective,
          config: _ctx.configModal,
          isAdaptativeLearning: false,
          onOnCloseMaterialsModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.configModal.showMaterials = false)),
          onOnGoToObjective: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToMaterials(_ctx.currentObjective.id))),
          onOnGoToEditObject: _ctx.goToEditObject,
          onOnDeleteObject: _ctx.deleteObject,
          onOnChooseMaterial: _ctx.getObjectsByLearningObjective
        }, null, 8, ["materials", "learningObjective", "config", "onOnGoToEditObject", "onOnDeleteObject", "onOnChooseMaterial"]))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.objective.name), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.objective.materials?.length) + " " + _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Objetos adicionados",
              en: "Added objects",
            })), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.user.role === 'TEACHER')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                id: `objective-add-material-btn`,
                class: "btn-outline-bg-white flex items-center gap-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToMaterials(_ctx.objective.id)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "md-add" }),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.add", { pt: "objeto", en: "object" })), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            id: `objective-view-material-btn`,
            class: "btn-simple w-10",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getObjectsByLearningObjective(_ctx.objective)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { name: "hi-solid-eye" })
            ]),
            _: 1
          }),
          (_ctx.user.role === 'TEACHER')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                id: `objective-edit-btn`,
                class: "btn-simple w-10",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToEditObjective(_ctx.objective)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "hi-solid-pencil" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasOrder)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                id: `objective-list-btn`,
                class: "btn-simple w-10",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('onOrder', _ctx.objective)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "md-list" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}